<template>
  <div>
    <div
      :id="nameDoomNode"
      :style="'overflow: hidden;position: relative; height:' + height"
    ></div>
  </div>
</template>

<script>
import * as echarts from "echarts/core";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from "echarts/components";
import { LineChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import { v4 as uuidv4 } from "uuid";

echarts.use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  LineChart,
  CanvasRenderer,
]);

export default {
  name: "LineChart",
  props: {
    data: {
      type: Array,
      required: true,
    },
    tipo: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "#3b82f6", // Azul por defecto
    },
    height: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      nameDoomNode: "line-chart-" + uuidv4(),
      myChart: null,
    };
  },
  watch: {
    data(newData, oldData) {
      if (this.myChart && newData !== oldData) {
        this.myChart.setOption(this.getChartOption());
      }
    },
  },
  mounted() {
    const dom = document.getElementById(this.nameDoomNode);
    this.myChart = echarts.init(dom, null, {
      renderer: "svg",
      useDirtyRect: false,
    });

    this.myChart.setOption(this.getChartOption());
    window.addEventListener("resize", this.myChart.resize);
  },
  methods: {
    getChartOption() {
      const fechas = this.data.map((item) => item.fecha);
      const totales = this.data.map((item) => item.total);

      return {
        title: {
          text: this.title,
          left: "center",
          textStyle: {
            fontSize: "10px",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: fechas,
          axisLabel: {
            rotate: 45,
            fontSize: 10,
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: this.tipo,
            type: "line",
            smooth: true,
            data: totales,
            lineStyle: {
              color: this.color,
              width: 2,
            },
            itemStyle: {
              color: this.color,
            },
            areaStyle: {
              color: this.color + "33", // color con transparencia
            },
          },
        ],
      };
    },
  },
};
</script>
